export const GET_SHORTCUTS_BLOCK_BY_ID_M = (id, preview: boolean) => `
  query {
    shortCutsBlock(id: "${id}", preview: ${preview}) {
    sys {
      id
    }
      heading
      columns
      linksCollection(limit: 6) {
        items {
          __typename
          ... on Link {
            linkText
            shortcutIconObject
            shortcutText
            reference {
              ...on Page {
                content {
                  __typename
                }
                slug
              }
              ...on FileBlock
              {
                imageVaultFile
              }
            }
            globalLinkItem
            url
          }
        }
      }
    }
  }
`;
